const enTranslations = {
  menu: {
    about: "Մեր Մասին ",
    services: "Ծառայություններ",
    partners: "Գործընկերներ",
    contacts: "Կապ"
  },

  aboutInfo: {
    title: "Մեր Մասին",
    description: " Մեր թիմն իրականացնում է անվտանգության համակարգերի նախագծում և տեղակայում:",
    main: "«Հովեր Սիսթեմս» ՍՊԸ-ն հիմնադրվել է 2022թ-ին։ Մեր թիմն իրականացնում է անվտանգության համակարգերի (հրդեհի ազդարարման, ձայնային ազդարարման, մուտքի վերահսկման, տեսահսկման, անձնակազմի կանչի, հյուրանոցային փականների, հեռահաղորդակցման  համակարգերի) նախագծում և իրականացում։ Ընկերությունում աշխատող ինժեներական անձնակազմն ունի շուրջ 15 տարվա աշխատանքային փորձ անվտանգության համակարգերի ոլորտում որի ընթացքում ձեռք են բերվել մի շարք հավաստագրեր Եվրոպական բրենդների կողմից:"},

  services: {
    title: "Ծառայություններ",
    description: "Մեր բարձրակարգ մասնագետները կօգնեն գտնել և իրագործել լավագույն լուծումները",
    service1: "Հրդեհի ազդարարման համակարգեր",
    service2: "Գազային հրդեհաշիջման համակարգեր",
    service3: "Ձայնային ազդարարման համակարգեր",
    service4: "Պաշտպանության համակարգեր",
    service5: " Մուտքի վերահսկման համակարգեր",
    service6: " Անձնակազմի կանչի համակարգեր",
    service7: "Էլեկտրոնային փականների համակարգեր",
    service8: "Հյուրանոցային էներգախնայման համակարգեր",
    service9: "Հեռահաղորդակցման համակարգեր",
    service10: "Տեսահսկաման համակարգեր",
  },

  companies: {
    title: "Ընկերություններ",
    description: "Ընկերություններ, որոնց հետ մենք համագործակցում ենք",
  },
  
  contacts: {
    title: "Կապ մեզ հետ",
    description: "Կապ հաստատեք մեզ հետ ցանկացած հարցի դեպքում",
    founder: "Հովհաննես Հ. Ալավերդյան ",
    position: " «Հովեր Սիսթեմս» ՍՊԸ հիմնադիր և տնօրեն",
    addressLabel: "Հասցե:",
    address: " Հայաստան, ք. Երևան, Մամիկոնյանց 27",
    telLabel: "Հեռախոս:",
    tel: "+374 95 64 61 23",
    emailLabel: "Էլ. փոստ:",
    email: "info@hoversystems.am",
    email2: "hoversystemsarmenia@gmail.com"
  },
};

export default enTranslations;
